
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alternatives",
      function () {
        return require("private-next-pages/alternatives.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alternatives"])
      });
    }
  